






























import {Component, Prop, Ref, Vue} from 'vue-property-decorator';
import JdsIcon from "@/design-system/icons/JdsIcon.vue"
import anime from "animejs"
import JdsGlyph from "@/design-system/icons/JdsGlyph.vue"

/**
 * @status stable
 * @published 4.0.0
 * @changelog 4.0.0 Published.
 */
@Component({
    components: {JdsGlyph, JdsIcon}
})
export default class JdsJobTileListLayout extends Vue {

    @Prop({default: false, type: Boolean}) showHeaders!: boolean;

    @Prop({default: null}) sortBy!: 'name'|'status'|null;
    @Prop({default: null}) sortDirection!: 'asc'|'desc'|null;


    @Ref() listEl!: HTMLElement;

    enter(el: HTMLElement, done: ()=>void) {
        // TODO: only show this animation on initial load, or when making changes to the list. Don't show it every time.
        let i = Array.prototype.indexOf.call(el.parentNode?.children, el);
        // let subItems = el.querySelectorAll('.jdsa-cell');

        anime.timeline({
            easing: 'easeOutBack',
            complete: done,
        }).add({
            targets: el,
            translateX: [-50, 0],
            scaleY: [0.2, 1],
            opacity: [0, 1],
            duration: 300,
            delay: i * 25,
        })
        // .add({
        //     targets: subItems,
        //     easing: 'easeOutExpo',
        //     translateY: [-20, 0],
        //     opacity: [0, 1],
        //     duration: 100,
        //     delay: anime.stagger(40),
        // }, 150 + (i * 40));
    }

    leave(el: Node, done: ()=>void) {
        done();
    }
}
